import { Select } from '@idaho-aeyc/ui-kit';
import styled, { createGlobalStyle } from 'styled-components';

export const DROPDOWN_CLASS = 'grouped-event-type-dropdown';

export const SGroupedSelect = styled(Select)`
  && {
    width: 100%;

    .ant-select-selection-item {
      font-weight: 400 !important;
    }

    .ant-select-selector {
      padding: 4px 8px;
      transition: all 0.3s;
    }

    &:hover .ant-select-selector {
      border-color: #0197b8 !important;
    }

    &.ant-select-focused .ant-select-selector,
    &.ant-select-open .ant-select-selector {
      border-color: #005678 !important;
      box-shadow: 0 0 0 2px rgba(0, 86, 120, 0.2) !important;
    }

    &.ant-select-disabled {
      .ant-select-selector {
        background-color: #f5f5f5 !important;
        border-color: #dedede !important;
      }

      .ant-select-selection-item {
        color: #808080 !important;
      }
    }
  }
`;

export const GroupedDropdownStyles = createGlobalStyle`
  .${DROPDOWN_CLASS} {
    .ant-select-item-group {
      background-color: #f4f5f8;
      font-weight: 700 !important;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.88);
      padding: 8px 12px 8px 12px !important;
      cursor: default;
      border-top: 1px solid #f0f0f0;
      display: flex;
      align-items: center;
      min-height: 40px;
      > * {
        font-weight: 700 !important;
      }

      &:first-child {
        border-top: none;
        margin-top: 0;
      }
      .ant-select-item-group-label {
        font-weight: 700 !important;
      }
    }

    .ant-select-item-option-grouped {
      padding-left: 24px !important;
    }
  }
`;
